<div class="selected-data-source">
  <div class="datasource-display">
    <div class="datasource-pill">
      @if (datasource.icon) {
        <fa-icon [icon]="datasource.icon"></fa-icon>
      }
      <span class="datasource-title">{{ datasource.title }}</span>
    </div>

    <div class="autosuggest-input">
      <input
        type="text"
        #searchInput
        class="form-control"
        [value]="typedQuery"
        (input)="onInput(searchInput.value)"
        (keydown)="onKeyDown($event)"
        placeholder="{{
          'datasource-selector.placeholder.type-to-search' | translate
        }}"
      />
      @if (isLoading) {
        <app-loading [size]="'1x'"></app-loading>
      }
    </div>
  </div>

  @if (suggestionsActive) {
    <div class="suggest-dropdown">
      @if (suggestions.length > 0) {
        <ul class="suggest-items">
          @for (suggestion of suggestions; track suggestion; let i = $index) {
            <li
              class="suggest-item"
              [ngClass]="{ active: i === selectedSuggestIndex }"
              (click)="selectSuggestion(suggestion)"
            >
              <span class="icon">
                @if (suggestion.icon) {
                  <fa-icon [icon]="suggestion.icon"></fa-icon>
                }
              </span>
              <span
                class="suggestion-title"
                [innerHTML]="suggestion.title | highlight: typedQuery"
              ></span>
            </li>
          }
        </ul>
      }
      @if (isLoading) {
        <div class="loading">
          {{ "datasource-selector.searching" | translate }}
        </div>
      }
      @if (suggestions.length === 0 && !isLoading) {
        <div class="no-results">
          {{ "search-suggest.message.no-suggestions-found" | translate }}
        </div>
      }
    </div>
  }
</div>
